import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const heightUnit: AnswerPathTreeNode = { path: 'heightUnit', nodeId: NodeIds.insuredHeightUnit };
